import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import clientService from '../../services/ClientService';
import { useDispatch } from 'react-redux';



export const initialState = {
	loading: false,
	message: '',
	list:null,
}



export const checkListAll = createAsyncThunk('checklist/list',async (data, { rejectWithValue }) => {
	
	try {
		const response = await clientService.getCheckList()
		
        return response.data;
		
		
	} catch (err) {
		
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const checkListSlice = createSlice({
	name: 'checklist',
	initialState,
	reducers: {
			
		checkList: (state, action) => {
			state.loading = true
			state.list = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(checkListAll.pending, (state) => {
                
				state.loading = false
			})
			.addCase(checkListAll.fulfilled, (state, action) => {
				
                state.loading = true
				state.list = action.payload
			})
			
	},
})

export const { 
	checkList,
    
    
} = checkListSlice.actions

export default checkListSlice.reducer